import { Component } from 'preact'
import $ from 'jquery'
import selectize from 'selectize' // eslint-disable-line no-unused-vars
import CategorySelector from '../category-selector/CategorySelector'

export default class CategorySelect extends Component {
  constructor () {
    super()

    this.setState({
      publishIn: 'community'
    })

    this.handleRadioInputChange = this.handleRadioInputChange.bind(this)
  }

  handleRadioInputChange (event) {
    if ($('select.qa-category-select').length) {
      $('select.qa-category-select')[0].selectize.destroy()
    }

    this.setState({
      publishIn: event.target.value
    })
  }

  render (props, state) {
    const { categories, forum_id, error, isKnowledgeBaseEnabled, onUpdate } = props
    const { publishIn } = state
    const isKnowledgeBaseCategorySelected = state.publishIn === 'knowledgeBase'
    let className = 'article-creator__sidebar-form form-group'
    if (error) {
      className += ' error'
    }

    let filteredKnowledgeBaseCategories = []
    let filteredCategories = []
    let hasChildCategories = false

    if (isKnowledgeBaseEnabled) {
      filteredKnowledgeBaseCategories = categories.filter(categoryGroup => categoryGroup.type === 1)
      filteredCategories = filteredKnowledgeBaseCategories

      if (filteredKnowledgeBaseCategories.length) {
        hasChildCategories = !!filteredKnowledgeBaseCategories[0].categories
      }
    }

    const filteredCommunityCategories = categories.filter(categoryGroup => categoryGroup.type !== 1)

    if (!isKnowledgeBaseCategorySelected) {
      filteredCategories = filteredCommunityCategories
    }

    return (
      <div class={className}>
        <h2 class='article-creator__sidebar-form-heading'>Publish in *</h2>
        {filteredCategories.length && hasChildCategories &&
        <div class='article-creator__sidebar-form-publish-in'>
          <div class='article-creator__sidebar-form-publish-in-radio-box'>
            <input
              id='communityCategory'
              class='article-creator__sidebar-form-publish-in-radio-box-input'
              type='radio'
              name='publishIn'
              onChange={this.handleRadioInputChange}
              value='community'
              checked={publishIn === 'community'}
            />
            <label class='article-creator__sidebar-form-publish-in-radio-box-label' for='communityCategory'>Community</label>
          </div>
          <div class='article-creator__sidebar-form-publish-in-radio-box article-creator__sidebar-form-publish-in-radio-box--knowledgeBase'>
            <input
              id='knowledgeBaseCategory'
              class='article-creator__sidebar-form-publish-in-radio-box-input'
              type='radio'
              name='publishIn'
              onChange={this.handleRadioInputChange}
              value='knowledgeBase'
              checked={publishIn === 'knowledgeBase'}
            />
            <label class='article-creator__sidebar-form-publish-in-radio-box-label' for='knowledgeBaseCategory'>Knowledge Base</label>
          </div>
        </div>}
        <CategorySelector
          categories={filteredCategories}
          selectedCategoryId={forum_id}
          onUpdate={onUpdate}
          keyToUpdate='forum_id'
        />
      </div>
    )
  }
}
